<template>
  <v-card flat class="model-bar">
    <v-app-bar elevation="1" class="px-13">
      <v-app-bar-title class="text-primary text-h6 font-weight-bold">
        Models
      </v-app-bar-title>
      <v-row>
        <v-col>
          <SiteAutocomplete
            class="mt-6 mr-5"
            :items="sitesWithAnalyticsModels"
            v-model="selectedSite"
            @update:modelValue="setDefaultSiteFromAnalyticsDomain"
          />
        </v-col>
        <v-col>
          <v-text-field
            class="mt-6 mr-5"
            v-model="searchTerm"
            hide-details
            prepend-inner-icon="mdi-magnify"
            single-line
            bg-color="white"
            variant="outlined"
            density="compact"
            :placeholder="placeholder"
            :clearable="true"
            @click:clear="handleSearchInput"
            @update:modelValue="handleSearchInput"
          />
        </v-col>
      </v-row>

      <!-- Add Button -->
      <template v-slot:append>
        <v-btn
          v-if="userCanUpdate || userCanCreate || userCanDelete"
          class="rounded-2 mr-3"
          color="primary"
          variant="flat"
          size="large"
          @click="handleAddAnalyticsModel"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold"
          >
            {{ $route.meta.buttonLabel }}
          </div>
        </v-btn>
      </template>
      <v-spacer />
    </v-app-bar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SiteAutocomplete from '@/Core.UI.Domain/Components/SiteAutocomplete.vue';

export default {
  name: 'ModelBar',

  components: { SiteAutocomplete },

  data() {
    return {
      searchTerm: '',
      selectedSite: null,
    };
  },

  async created() {
    await this.getSitesWithAnalyticsModels();
    this.setDefaultSiteFromAnalyticsDomain(this.defaultSite);
  },

  beforeUnmount() {
    this.setAnalyticsModelsCurrentRoute('');
  },

  computed: {
    ...mapGetters({
      sitesWithAnalyticsModels:
        'AnalyticsStore/AnalyticsModelsStore/sitesWithAnalyticsModels',
      defaultSite: 'session/defaultSite',
    }),

    placeholder() {
      return this.$route.meta.placeholder || 'Search for a Model';
    },

    userCanCreate() {
      return this.$can('create', 'analytics');
    },
    userCanDelete() {
      return this.$can('delete', 'analytics');
    },
    userCanUpdate() {
      return this.$can('update', 'analytics');
    },
  },

  watch: {
    $route() {
      this.setDefaultSiteFromAnalyticsDomain(this.defaultSite);
      this.clearSearchTerm();
    },
  },

  methods: {
    ...mapActions({
      getSitesWithAnalyticsModels:
        'AnalyticsStore/AnalyticsModelsStore/getSitesWithAnalyticsModels',
      getAnalyticsModelsBySiteId:
        'AnalyticsStore/AnalyticsModelsStore/getAnalyticsModelsBySiteId',
      setAnalyticsModelsCurrentRoute:
        'AnalyticsStore/AnalyticsModelsStore/setAnalyticsModelsCurrentRoute',
      setDefaultSite: 'session/setDefaultSite',
    }),

    ...mapMutations({
      setAnalyticsModelSearchTerm:
        'AnalyticsStore/AnalyticsModelsStore/ANALYTICS_MODEL_SEARCH_TERM',
    }),

    setDefaultSiteFromAnalyticsDomain(selectedSite) {
      this.selectedSite = selectedSite || this.sitesWithAnalyticsModels[0];
      this.setDefaultSite(this.selectedSite);

      this.getAnalyticsModelsBySiteId({
        selectedSite: this.selectedSite,
      }).then(() => {
        this.setAnalyticsModelsCurrentRoute(this.$route.name);
        this.clearSearchTerm();
      });
    },

    handleAddAnalyticsModel() {
      // TODO: This is a temporary solution. This route will be replaced by the correct one, when the domain's refactor is done
      this.$router.push({
        name: 'ModelCreate',
        params: { siteId: this.selectedSite.siteId || this.selectedSite.id },
      });
    },

    handleSearchInput(value) {
      if (typeof value === 'object') {
        this.setAnalyticsModelSearchTerm('');
      } else {
        this.setAnalyticsModelSearchTerm(value);
      }
    },

    clearSearchTerm() {
      this.searchTerm = '';
      this.setAnalyticsModelSearchTerm('');
    },
  },
};
</script>
<style lang="scss" scoped>
.model-bar {
  z-index: 1;
}

.v-input {
  max-width: 700px !important;
}

:deep(.v-field__input) {
  color: $primary !important;
}

:deep(.bg-white) {
  color: $primary !important;
}
</style>
